const INTERRUPTED_CHANGE_KEY = "cfc:change-interrupted-by-login";

let changesAwaitingToken = 0;

const rememberInterruptedChange = (isWaiting: boolean): void => {
  try {
    if (isWaiting) {
      sessionStorage.setItem(INTERRUPTED_CHANGE_KEY, "true");
    } else {
      sessionStorage.removeItem(INTERRUPTED_CHANGE_KEY);
    }
  } catch {
    // Storage can be unavailable (e.g. blocked site data); the notice is best effort.
  }
};

/**
 * Marks the session while a request that may change data (any method but GET, HEAD or OPTIONS) waits
 * for a fresh token. A failed refresh sends the user to the login page before the wait ends, so the
 * mark survives only when such a request was cut off that way.
 */
export const whileChangeAwaitsToken = async <T>(wait: Promise<T>): Promise<T> => {
  changesAwaitingToken += 1;
  rememberInterruptedChange(true);
  try {
    return await wait;
  } finally {
    changesAwaitingToken -= 1;
    if (changesAwaitingToken === 0) {
      rememberInterruptedChange(false);
    }
  }
};

/** Whether such a request was cut off by a login redirect in this tab; clears the mark. */
export const takeInterruptedChange = (): boolean => {
  try {
    const wasInterrupted = sessionStorage.getItem(INTERRUPTED_CHANGE_KEY) !== null;
    sessionStorage.removeItem(INTERRUPTED_CHANGE_KEY);
    return wasInterrupted;
  } catch {
    return false;
  }
};
